module.exports = __webpack_public_path__ + "static/img/phone.77d73640.png";